import './PrintableOrder.css';

function PrintableOrder({ order }) {
  if (!order) return null;

  return (
    <div className="printable-order">
      <div className="print-header">
        <div>
          <h1>PICK ORDER</h1>
        </div>
        <div className="order-info">
          <p><strong>Order #:</strong> {order.idTrans}</p>
          <p><strong>Date:</strong> {new Date(order.transDate).toLocaleDateString()}</p>
          <p><strong>Ref:</strong> {order.CustomerRef || 'N/A'}</p>
        </div>
      </div>

      <div className="shipping-info">
        <div className="ship-to">
          <h3>SHIP TO</h3>
          <p><strong>{order.delName}</strong></p>
          <p>{order.delAddress}</p>
          <p>{order.delCity}, {order.delState} {order.delZip}</p>
          {order.delPhone && <p>📞 {order.delPhone}</p>}
        </div>
        <div className="shipping-details">
          <h3>SHIPPING DETAILS</h3>
          <p><strong>Carrier:</strong> {order.carrier || 'N/A'}</p>
          <p><strong>Tracking:</strong> {order.carrierPro || 'N/A'}</p>
          <p><strong>Service:</strong> {order.shipping_service_type || 'N/A'}</p>
          {order.shipping_estimated_days && 
            <p><strong>Est. Days:</strong> {order.shipping_estimated_days}</p>
          }
        </div>
      </div>

      <div className="order-items">
        <h3>ORDER ITEMS</h3>
        <table>
          <thead>
            <tr>
              <th style={{width: '15%'}}>Item #</th>
              <th style={{width: '40%'}}>Description</th>
              <th style={{width: '10%'}}>Qty</th>
              <th style={{width: '35%'}}>Notes</th>
            </tr>
          </thead>
          <tbody>
            {order.items?.map((item) => (
              <tr key={item.idTrans2}>
                <td>{item.itemNumber}</td>
                <td>{item.itemName}</td>
                <td>{item.transQty}</td>
                <td>{item.notes || ''}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="print-footer">
        <p>Printed: {new Date().toLocaleString()} | Order #{order.idTrans}</p>
      </div>
    </div>
  );
}

export default PrintableOrder; 